module.exports = __webpack_public_path__ + "static/media/Patronato-Bofedal.cfa46638.JPG";